(() => {
  const root = document.querySelector('[data-dealer-workbench-root]');
  if (!root) return;

  const page = root.closest('[data-wb-app]') || root.closest('.dealer-workbench-page');
  const config = window.SC_WORKBENCH || {};
  const laneIds = ['reorder', 'standards', 'service'];
  let currentScreen = 'overview';
  let initialScreenLocked = false;

  function money(cents) {
    try {
      return Shopify.formatMoney(Number(cents || 0), config.moneyFormat || '${{amount}}');
    } catch (error) {
      return `$${(Number(cents || 0) / 100).toFixed(2)}`;
    }
  }

  function qs(selector, ctx = root) {
    return ctx.querySelector(selector);
  }

  function qsa(selector, ctx = root) {
    return Array.from(ctx.querySelectorAll(selector));
  }

  function parseHash() {
    const hash = window.location.hash || '';
    if (hash === '#dealer-workbench-account') return 'account';
    if (hash === '#dealer-workbench-workspace') return 'workspace';
    if (hash === '#dealer-workbench-overview') return 'overview';
    if (hash === '#dealer-workbench-quick-order') return 'quick-order';
    return '';
  }

  function contextualScreen(detail = window.SC_WORKBENCH_LAST_RENDER) {
    const fromHash = parseHash();
    if (fromHash) return fromHash;
    const activeCount = Array.isArray(detail?.currentItems) ? detail.currentItems.length : 0;
    return activeCount > 0 ? 'workspace' : 'overview';
  }

  function setScreen(screen, opts = {}) {
    const value = ['overview', 'workspace', 'account', 'quick-order'].includes(screen) ? screen : 'overview';
    currentScreen = value;
    root.dataset.wbScreen = value;
    if (page) page.dataset.wbScreen = value;

    qsa('[data-wb-panel]').forEach((panel) => {
      const active = panel.dataset.wbPanel === value;
      panel.hidden = !active;
      panel.setAttribute('aria-hidden', active ? 'false' : 'true');
      panel.classList.toggle('is-active', active);
    });

    qsa('[data-wb-action="set-screen"]').forEach((button) => {
      const active = button.dataset.wbScreen === value;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    if (opts.updateHash !== false) {
      const hash = value === 'workspace'
        ? '#dealer-workbench-workspace'
        : value === 'account'
          ? '#dealer-workbench-account'
          : value === 'quick-order'
            ? '#dealer-workbench-quick-order'
            : '#dealer-workbench-overview';
      if (window.location.hash !== hash) {
        history.replaceState({}, '', `${window.location.pathname}${window.location.search}${hash}`);
      }
    }

    if (value === 'workspace' && opts.focusHeading !== false) {
      const heading = qs('[data-sc-workbench-active-title]');
      if (heading) {
        heading.setAttribute('tabindex', '-1');
        heading.focus({ preventScroll: true });
      }
    }
  }

  function openCartDrawer(trigger) {
    const drawer = document.querySelector('cart-drawer');
    const cartIcon = document.querySelector('#cart-icon-bubble');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open(trigger || cartIcon || undefined);
      return true;
    }
    if (cartIcon) {
      cartIcon.click();
      return true;
    }
    if (config.cartUrl) {
      window.location.assign(config.cartUrl);
      return true;
    }
    return false;
  }

  function switchList(listId) {
    if (!listId) return;
    const target = qs(`[data-wb-action="switch-list"][data-wb-list-id="${CSS.escape(listId)}"]`) ||
      qs(`[data-sc-workbench-list-pill="${CSS.escape(listId)}"]`);
    target?.click();
  }

  function lineTotal(item) {
    const qty = Math.max(1, Number(item?.qtyHint || 1));
    return qty * Number(item?.priceCents || 0);
  }

  function summarizeLane(items) {
    const safe = Array.isArray(items) ? items : [];
    return safe.reduce((acc, item) => {
      acc.count += 1;
      acc.ready += item?.available === false ? 0 : 1;
      acc.subtotal += lineTotal(item);
      return acc;
    }, { count: 0, ready: 0, subtotal: 0 });
  }

  function syncLaneCards(detail) {
    const state = detail?.state || {};
    const itemsByList = state.itemsByList || {};
    const active = detail?.activeListId || '';

    laneIds.forEach((laneId) => {
      const summary = summarizeLane(itemsByList[laneId]);
      qsa(`[data-wb-role="lane-count"][data-wb-lane-id="${laneId}"]`).forEach((node) => {
        node.textContent = String(summary.count);
      });
      qsa(`[data-wb-role="lane-ready"][data-wb-lane-id="${laneId}"]`).forEach((node) => {
        node.textContent = String(summary.ready);
      });
      qsa(`[data-wb-role="lane-subtotal"][data-wb-lane-id="${laneId}"]`).forEach((node) => {
        node.textContent = money(summary.subtotal);
      });
      qsa(`[data-wb-role="lane-card"][data-wb-lane-id="${laneId}"]`).forEach((card) => {
        card.classList.toggle('is-active', active === laneId);
      });
    });

    root.classList.toggle('has-selection', Array.isArray(detail?.selectedKeys) && detail.selectedKeys.length > 0);

    if (!initialScreenLocked) {
      setScreen(contextualScreen(detail), { updateHash: false, focusHeading: false });
      initialScreenLocked = true;
    }
  }

  document.addEventListener('click', (event) => {
    const cartBtn = event.target.closest('[data-wb-action="open-cart-drawer"]');
    if (cartBtn) {
      event.preventDefault();
      openCartDrawer(cartBtn);
      return;
    }

    const screenBtn = event.target.closest('[data-wb-action="set-screen"]');
    if (screenBtn) {
      event.preventDefault();
      setScreen(screenBtn.dataset.wbScreen || 'overview');
      return;
    }

    const laneBtn = event.target.closest('[data-wb-action="open-lane-card"]');
    if (laneBtn) {
      event.preventDefault();
      switchList(laneBtn.dataset.wbListId || 'reorder');
      setScreen('workspace', { focusHeading: true });
      return;
    }

    const listSwitch = event.target.closest('[data-wb-action="switch-list"]');
    if (listSwitch) {
      setScreen('workspace', { updateHash: true, focusHeading: false });
    }
  });

  root.addEventListener('sc:workbench:render', (event) => {
    syncLaneCards(event.detail || {});
  });

  window.addEventListener('hashchange', () => {
    const screen = parseHash();
    if (screen) {
      setScreen(screen, { updateHash: false, focusHeading: false });
      initialScreenLocked = true;
    }
  });

  setScreen(contextualScreen(), { updateHash: false, focusHeading: false });

  if (window.SC_WORKBENCH_LAST_RENDER) {
    syncLaneCards(window.SC_WORKBENCH_LAST_RENDER);
  }
})();
